export default __webpack_public_path__ + "static/media/LAS0190.34I-39639_-23670_0.35f66d22.jpg";